import { Mail, Clock } from "lucide-react";
import LegalLayout from "@/components/LegalLayout";

export default function ContactUs() {
  return (
    <LegalLayout title="Contact Us" testId="contact-us-page">
      <p>
        We're here to help with questions about your account, your AI career assessment, or a payment made
        on PathfinderAiClub. Reach out and we'll get back to you as soon as we can.
      </p>

      <div className="border-2 border-[#0A0A0A] rounded-xl p-5 bg-[#FEF9E7] flex items-start gap-3">
        <Mail size={20} strokeWidth={2.5} className="shrink-0 mt-0.5" />
        <div>
          <p className="font-bold">Email support</p>
          <a href="mailto:support@pathfinderaiclub.com" data-testid="contact-support-email">
            support@pathfinderaiclub.com
          </a>
        </div>
      </div>

      <div className="border-2 border-[#0A0A0A] rounded-xl p-5 bg-white flex items-start gap-3">
        <Clock size={20} strokeWidth={2.5} className="shrink-0 mt-0.5" />
        <div>
          <p className="font-bold">Response time</p>
          <p className="text-[#52525B]">We typically respond within 1–2 business days.</p>
        </div>
      </div>

      <h2>What to include in your email</h2>
      <ul>
        <li>Your registered name and email address</li>
        <li>If it's about a payment: the order ID or transaction reference (from your Cashfree receipt)</li>
        <li>A clear description of the issue or question</li>
      </ul>

      <h2>Common queries</h2>
      <p>
        For payment-related questions, refunds, and cancellations, please see our{" "}
        <a href="/refund-policy">Refund &amp; Cancellation Policy</a>. For questions about how the platform
        works, see our <a href="/terms">Terms &amp; Conditions</a>.
      </p>
    </LegalLayout>
  );
}
